import React from "react";

const TravelInsuranceComparison = () => {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-center" style={{ fontWeight: 'bold' }}>
        Choose the Best Travel Insurance – UIC vs. CSI
      </h1>
      <p className="mb-4 text-center" style={{color:'#000'}}>
        When planning a trip, having reliable travel insurance in Pakistan ensures peace of mind and protection against unexpected events. Malik Express Travel & Tours offers two top choices: United Insurance Company of Pakistan (UIC) and Crescent Star Insurance Limited (CSI). Both providers offer online travel insurance in Pakistan, but which one is the best for your needs? Check out the comparison below to make an informed decision.
      </p>
      <h2 className="text-2xl font-bold text-center mb-4">
        Quick Comparison: <span className="text-blue-600">UIC vs. CSI Travel Insurance</span>
      </h2>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-300">
          <thead>
            <tr className="bg-gray-200">
              <th className="p-2 border border-gray-300">Feature</th>
              <th className="p-2 border border-gray-300">United Insurance Company (UIC)</th>
              <th className="p-2 border border-gray-300">Crescent Star Insurance (CSI)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="p-2 border border-gray-300">Company Rating</td>
              <td className="p-2 border border-gray-300">AA+ by PACRA (Highly Reliable)</td>
              <td className="p-2 border border-gray-300">SECP Registered, Trusted Since 1957</td>
            </tr>
            <tr className="bg-gray-100">
              <td className="p-2 border border-gray-300">Coverage Areas</td>
              <td className="p-2 border border-gray-300">Schengen, Worldwide, Student, Group Travel</td>
              <td className="p-2 border border-gray-300">General Travel, Budget-Friendly Plans</td>
            </tr>
            <tr>
              <td className="p-2 border border-gray-300">Key Benefits</td>
              <td className="p-2 border border-gray-300">Medical Emergencies, Trip Cancellations, Lost Baggage, Flight Delays, Accidental Death, Emergency Repatriation</td>
              <td className="p-2 border border-gray-300">Medical Coverage, Trip Cancellations, Baggage Loss, Affordable Rates</td>
            </tr>
            <tr className="bg-gray-100">
              <td className="p-2 border border-gray-300">Best For</td>
              <td className="p-2 border border-gray-300">Business Travelers, Schengen Visa, Students, Corporate Travel</td>
              <td className="p-2 border border-gray-300">Budget Travelers, Short Trips, Quick Policy Issuance</td>
            </tr>
            <tr>
              <td className="p-2 border border-gray-300">Claim Processing</td>
              <td className="p-2 border border-gray-300">Efficient with Strong Financial Backing</td>
              <td className="p-2 border border-gray-300">Fast Policy Issuance, Competitive Premiums</td>
            </tr>
            <tr className="bg-gray-100">
              <td className="p-2 border border-gray-300">Online Booking</td>
              <td className="p-2 border border-gray-300">Available via Malik Express</td>
              <td className="p-2 border border-gray-300">Available via Malik Express</td>
            </tr>
          </tbody>
        </table>
      </div>
      <h3 className="text-lg font-semibold text-blue-600 mt-4">Which Travel Insurance is Right for You?</h3>
      <ul className="mt-2 list-disc pl-5 " style={{ listStyleType: 'disc',marginLeft: "15px" }}>
        <li>Choose UIC if you need Schengen visa insurance, student travel insurance, or a highly reliable provider with an AA+ rating.</li>
        <li>Choose CSI if you want budget-friendly travel insurance with quick policy issuance for general trips.</li>
      </ul>
      <p className="mt-2" style={{color:'#000'}}>
        No matter which option you select, Malik Express Travel & Tours makes it easy to compare travel insurance plans online and book instantly.
      </p>
      <h2 className="text-2xl font-bold mb-4 mt-4">
        Get Your Travel Insurance Today!
      </h2>
      <p className="mb-4" style={{color:'#000'}}>
      Don’t take risks while traveling—secure your trip with the best online travel insurance in Pakistan. Book now with Malik Express for instant policy issuance and worry-free travel!      </p>
      
    </div>
  );
};

export default TravelInsuranceComparison;
